import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { SalesOrderStatus } from './api';

/**
 * One status, one colour, everywhere it appears.
 *
 * The colours carry the distinction that matters at a glance: grey for not yet on the floor, blue
 * for work in progress, green for gone, dark for finished with.
 *
 * `back_order` is ORANGE and deliberately not green. It is the one status people misread — an
 * order shipped short looks "shipped" in a list, and the rest of it is then nobody's job. Legacy
 * counts it among the OPEN orders for exactly that reason, and there is a nightly job built around
 * chasing them.
 */
const COLOURS: Record<SalesOrderStatus, string> = {
  open: 'gray',
  released: 'blue',
  in_wave_pick: 'blue',
  picked: 'cyan',
  back_order: 'orange',
  shipped: 'green',
  closed: 'dark',
};

export function SalesOrderStatusBadge({ status }: { status: SalesOrderStatus }) {
  const { t } = useTranslation();
  return (
    <Badge color={COLOURS[status] ?? 'gray'} variant="light">
      {t(`salesOrders.statuses.${status}`)}
    </Badge>
  );
}
